(function () {

    function init() {
        const nav = document.getElementById("brand-category-nav");
        const container = document.getElementById("brand-category-links");
        const items = window.subCategories || [];

        if (!nav || !container) return;

        if (items.length === 0) {
            nav.style.display = "none";
            return;
        }

        container.innerHTML = "";

        items.forEach(item => {
            const li = document.createElement("li");
            li.className = "brand-category-item";

            const a = document.createElement("a");
            a.className = "brand-category-link";
            a.href = item.url;

            if (item.image) {
                const img = document.createElement("img");
                // 图片加载完成前沿用 skeleton 的闪烁背景
                img.className = "brand-category-image skeleton-image";
                img.onload = img.onerror = () => img.classList.remove("skeleton-image");
                img.alt = item.title;
                img.loading = "lazy";
                img.src = item.image;
                a.appendChild(img);
            } else {
                const placeholder = document.createElement("div");
                placeholder.className = "brand-category-image";
                a.appendChild(placeholder);
            }

            const span = document.createElement("span");
            span.className = "brand-category-title";
            span.textContent = item.title;
            a.appendChild(span);

            li.appendChild(a);
            container.appendChild(li);
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

})();